import { DefaultOptionType } from 'antd/lib/select';
import { IntlShape } from 'react-intl';
import { RegisterSection as messages } from '../messages';

export const getChannelOptions = (intl: IntlShape): DefaultOptionType[] =>
  Array.from({ length: 16 }, (_, channel) => ({
    value: channel + 1,
    label: `${intl.formatMessage(messages.channel)} ${channel + 1}`,
  }));
